module.exports = __webpack_public_path__ + "static/media/campus_1.3970eed7.png";